<template>
    <div>
        <div class="modal fade" id="fieldModal" tabindex="-1" role="dialog" aria-labelledby="confirmModalLabel"
             aria-hidden="true">

            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Field Editor</h5>
                        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">

                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="row mb-3">
                                <label for="nameInput" class="col-sm-3 col-form-label">Name</label>
                                <div class="col-sm-9">
                                    <input id="nameInput" type="text" class="form-control" placeholder="field name"
                                           v-model="field.name">
                                </div>
                            </div>
                            <div class="row mb-3">
                                <label for="fieldTypeOptions" class="col-sm-3 col-form-label">Field Type</label>
                                <div class="col-sm-9">
                                    <select id="fieldTypeOptions" class="form-select" v-model="field.field_type"
                                            @change="onFieldTypeSelected">
                                        <option v-for="fieldOption in model.fieldOptions">{{fieldOption}}</option>
                                    </select>
                                </div>
                            </div>

                            <div v-if="isNumeric" class="form-group row">
                                <label for="formatOptions" class="col-sm-3 col-form-label">Format</label>
                                <div class="col-sm-9">
                                    <select id="formatOptions" class="form-select" v-model="formatData.format">
                                        <option>none</option>
                                        <option>percentage</option>
                                    </select>
                                </div>
                            </div>

                            <div class="mb-3 row" v-if="field.field_type === 'Single Select'">
                                <label for="fieldTypeOptions" class="col-sm-3 col-form-label">Field Options</label>
                                <div class="col-sm-9">

                                    <div class="row mt-2" v-for="fieldOption in defaultOptions">
                                        <div class="col-sm-9">
                                            <input type="text" class="form-control" placeholder="select value"
                                                   v-model="fieldOption.value">
                                        </div>
                                        <div class="col-sm-3">
                                            <color-picker :color-object="fieldOption" color-field="color"></color-picker>
                                        </div>
                                    </div>

                                    <div class="row mt-2">
                                        <div class="col-sm-9">
                                            <a href="javascript:void(0)" @click="onAddOptionClick"
                                               class="btn btn-primary btn-sm"
                                               style="border-radius: 2rem !important;">add value</a>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div class="mb-3" v-if="field.field_type === 'Link to Object'">

                                <div class="list-group">
                                    <a v-for="table in tableOptions" href="javascript:void(0)"
                                       @click="onTableSelected(table)"
                                       class="list-group-item list-group-item-action"
                                       :class="defaultLinkOptions.table === table.id ? 'active' : ''">
                                        {{table.name}}
                                    </a>
                                </div>

                            </div>

                            <dynamic-field-options v-if="field.field_type === 'Dynamic'"
                                                   :field="field" :table="table"
                                                   :dynamic-field-data="dynamicFieldData"></dynamic-field-options>

                            <div class="mb-3" v-if="field.field_type === 'Collaborator'">

                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="setCurrentUserCheck"
                                        v-model="collaboratorSettings.currentUser ">
                                    <label class="form-check-label" for="setCurrentUserCheck">
                                        Set to current user
                                    </label>
                                </div>

                            </div>

                            <div class="mb-3" v-if="isDocument">

                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="pdfExportCheck"
                                           v-model="documentSettings.pdfExport">
                                    <label class="form-check-label" for="pdfExportCheck">
                                        Export to PDF
                                    </label>
                                </div>

                            </div>

                        </form>
                    </div>

                    <div v-if="errorMessage" class="alert alert-danger" role="alert">
                        {{errorMessage}}<br>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn modal-btn btn-primary " style="min-width: 150px;"
                                @click="yesHandler">Ok
                        </button>
                        <button type="button" class="btn modal-btn btn-secondary " style="min-width: 150px;"
                                @click="noHandler">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>


    import OnOffControl from "../../components/OnOffControl.vue";
    import ColorPicker from "../../components/ColorPicker.vue";
    import FieldService from "../../services/FieldService";
    import ArrayUtil from "../../utils/ArrayUtil";
    import DynamicFieldOptions from "../fields/DynamicFieldOptions.vue";
    import FieldUtil from "../../utils/FieldUtil";
    import AppService from "../../services/AppService";

    export default {
        name: 'FieldModal',
        components: {
            DynamicFieldOptions,
            ColorPicker, OnOffControl
        },
        props: {
            yesEvent: Function,
            field: Object,
            table: Object
        },
        computed: {
            tableOptions() {

                let newTables = this.app.tables.filter((availableTable) => {
                    return this.table.id !== availableTable.id
                })

                return newTables
            },
            isNumeric() {
                return new FieldUtil(this.field).isNumeric()
            },
            isDocument() {
                return this.field.field_type === 'Text' // || this.field.field_type === 'Attachment'
            },
            formatData() {
                return this.field.field_type === 'Number' ? this.numericSettings : this.dynamicFieldData
            }
        },
        data() {
            return {
                model: webase.model,
                service: new FieldService(),
                arrayUtil: new ArrayUtil(),
                app: webase.model.app,
                defaultColors: ['#009CE0', '#F44E3B', '#7B64FF', '#FE9200'],
                defaultOptions: [
                    {
                        value: '',
                        color: '#009CE0'
                    }
                ],
                defaultLinkOptions: {
                    table: ''
                },
                numericSettings: {
                    format: 'none'
                },
                dynamicFieldData: {
                    operand1Id: null,
                    operand2Id: null,
                    operator: 'add',
                    format: 'none'
                },
                collaboratorSettings: {
                    currentUser: false
                },
                documentSettings: {
                    pdfExport: false
                },
                errorMessage: null,
                currentModal: null,
                modalElement: null,
            }
        },
        mounted() {
            this.modalElement = document.getElementById('fieldModal')
            this.currentModal = new bootstrap.Modal(this.modalElement)

            this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)

            this.currentModal.show()

            if(this.field.field_type === 'Single Select' && this.field.metadata) {
                this.defaultOptions = this.field.metadata
            }
            else if(this.field.field_type === 'Collaborator' && this.field.metadata) {
                this.collaboratorSettings = this.field.metadata
            }
            else if(this.field.field_type === 'Dynamic' && this.field.metadata) {
                Object.assign(this.dynamicFieldData, this.field.metadata)
            }
            else if(this.field.field_type === 'Number' && this.field.metadata) {
                Object.assign(this.numericSettings, this.field.metadata)
            }
            else if(this.isDocument && this.field.metadata) {
                Object.assign(this.documentSettings, this.field.metadata)
            }
        },
        beforeUnmount() {
            this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
        },
        methods: {
            onModalHidden() {
                this.$emit('noEvent')
            },
            noHandler(e) {
                this.currentModal.hide()
            },
            yesHandler(e) {

                if (this.field.field_type === 'Single Select') {
                    this.serializeSingleSelectData()
                }
                else if (this.field.field_type === 'Collaborator') {
                    this.serializeCollaboratorSettings()
                }
                else if (this.field.field_type === 'Number') {
                    this.field.metadata = JSON.stringify(this.numericSettings)
                }
                else if (this.isDocument) {
                    this.field.metadata = JSON.stringify(this.documentSettings)
                }

                if (this.field.field_type === 'Dynamic') {
                    if( !this.validateAndSerializeDynamicField() ) {
                        return
                    }
                }

                if (this.field.id === null) {
                    this.create()
                } else {
                    this.update()
                }

                // need to reload the app in this case, so related tables reload
                if (this.field.field_type === 'Link to Object') {
                    new AppService().initApp(this.model.app.id)
                }

                // call the parent's "yesEvent"
                if (this.yesEvent) {
                    this.yesEvent()
                }

                // hide the modal
                this.noHandler()
            },
            create() {
                let request = {
                    field: this.field
                }

                this.service.create(request).then((response) => {
                    this.table.fields.push(response)
                }).catch((message) => {
                    console.log('error creating field')
                    console.log(message)
                })
            },
            update() {
                let request = {
                    field: {
                        name: this.field.name,
                        field_type: this.field.field_type,
                        metadata: this.field.metadata
                    }
                }

                this.service.update(this.field.id, request).then((response) => {
                    this.arrayUtil.update(this.table.fields, response)
                }).catch((message) => {
                    console.log('error updating field')
                    console.log(message)
                })
            },
            onAddOptionClick() {
                let nextColorIndex = this.defaultOptions.length % this.defaultColors.length
                this.defaultOptions.push({
                    value: '',
                    color: this.defaultColors[nextColorIndex]
                })
            },
            onTableSelected(selectedTable) {
                this.defaultLinkOptions.table = selectedTable.id
                this.field.child_model_id = selectedTable.id

                if (!this.field.name) {
                    this.field.name = selectedTable.name
                }
            },
            onFieldTypeSelected() {

                if (this.field.field_type === 'Link to Object' && this.tableOptions.length === 0) {
                    this.errorMessage = 'Another table is required to link to ' + this.table.name
                    return
                }

                this.errorMessage = null
            },
            serializeSingleSelectData() {
                let validOptions = []

                for (let i = 0; i < this.defaultOptions.length; i++) {

                    let fieldOption = this.defaultOptions[i]

                    if (fieldOption.value) {
                        validOptions.push(fieldOption)
                    }
                }

                if (validOptions.length > 0) {
                    this.field.metadata = JSON.stringify(validOptions)
                }
            },
            serializeCollaboratorSettings() {
                this.field.metadata = JSON.stringify(this.collaboratorSettings)
            },
            validateAndSerializeDynamicField() {
                if(this.dynamicFieldData.operand1Id && this.dynamicFieldData.operand2Id) {
                    this.field.metadata = JSON.stringify(this.dynamicFieldData)
                    return true
                }

                this.errorMessage = 'A dynamic field requires two numeric fields to operate'
                return false
            }
        }
    }
</script>